import React, { useCallback } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AppErrorsWrapper from "./app-errors-wrapper";
import { useAppSelector, useAppDispatch } from "src/stores/redux/hooks";
import { getIsAppErrorsSidebarOpen, getLoadLocalErrors } from "../../helpers/selectors";
import { setShowAppErrorsSidebarAction } from "src/stores/redux/features/flowdesigner/flowdesigner.slice";
import { useParams } from "react-router";
import { navigateToFlow } from "../../helpers/navigation.utils";
import { FlowUrlProps } from "../../flowdesigner";

interface AppErrorsSidebarProps {
    app: any;
    appStatus?: string;
    isAutomatedGroup?: boolean;
    moveToAppGroups?: () => void;
}

const AppErrorsSidebar: React.FC<AppErrorsSidebarProps> = ({
    app,
    appStatus,
    isAutomatedGroup = false,
    moveToAppGroups
}) => {
    const { appName, flowName } = useParams<FlowUrlProps>();
    const isAppErrorsSidebarOpen = useAppSelector(getIsAppErrorsSidebarOpen);
    const loadLocalErrors = useAppSelector(getLoadLocalErrors);
    const dispatch = useAppDispatch();
    const handleCloseAppErrors = useCallback(() => {
        dispatch(setShowAppErrorsSidebarAction(false));
        navigateToFlow(appName, flowName);
    }, [dispatch]);

    if (!app || !isAppErrorsSidebarOpen) return;
    return (
        <Box
            sx={{
                height: "100%",
                backgroundColor: "white",
                borderLeft: "1px solid #e0e0e0",
                display: "flex",
                flexDirection: "column",
                position: "relative"
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "16px",
                    borderBottom: "1px solid #e0e0e0"
                }}
            >
                <Typography variant="h6" component="h2">
                    App Errors
                </Typography>
                <IconButton onClick={handleCloseAppErrors} size="small">
                    <CloseIcon />
                </IconButton>
            </Box>

            {/* Content */}
            <Box
                sx={{
                    flex: 1,
                    overflow: "hidden"
                }}
            >
                <AppErrorsWrapper
                    app={app}
                    appStatus={appStatus}
                    loadLocal={loadLocalErrors}
                    isAutomatedGroup={isAutomatedGroup}
                    moveToAppGroups={moveToAppGroups}
                    onClose={handleCloseAppErrors}
                />
            </Box>
        </Box>
    );
};

export default AppErrorsSidebar;
